import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";
import { checkTokenServ } from "@api/user";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  const { fullPath } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    oAuth();
  } else {
    // if (name !== "Login") {
    //   push
    //     ? router.push({ path: "/login" })
    //     : router.replace({ path: "/login" });
    // }
    alert("请使用微信浏览器");
  }
}

export function checkToken() {
  checkTokenServ().then(res => {
    let resultKey = res.resultKey;
    if (resultKey === "0") {
      return true;
    } else {
      return false;
    }
  });
}
